<template>
	<div class="main">
		<div class="product">
            <div class="pro">
                <router-link :to="{path:'/'}" class="link"><span >{{$t('nav.home')}} > </span></router-link>
                <router-link :to="{path:'/product'}" class="link"><span >{{$t('nav.pro')}}</span></router-link> 
                <template v-if="product.name">
                    <span v-if="$i18n.locale == 'zh'"> > {{obj.name}}</span>
                    <span v-else-if="$i18n.locale == 'en'"> > {{obj.english}}</span>
                    <span v-else> > {{obj.e_name}}</span>
                </template>
            </div>
		    <div class='title'>
               {{product.name}}
            </div>
            <div class="pro_center">
                <!-- 产品信息 -->
                <div class="chan">{{$t('pro.proxi')}}</div>
                <div class="pro_cen">
                    <div class="cu_one">
                        <div>{{$t('pro.zname')}}：{{product.name}} </div>
                        <div>{{$t('pro.yname')}}：{{product.english}} </div>
                        <div>{{$t('pro.cash')}}：{{product.cas}} </div>
                        <div style="display:flex;"> <span>{{$t('pro.fzs')}}：</span> <span v-html="product.formula"></span></div>
                        <div>{{$t('pro.fzl')}}：{{product.formula_num}}</div>
                    </div>
                </div>
                <!-- 产品属性 -->
                <div class="chan">{{$t('pro.cpsx')}}</div>
                <div class="pro_cen">
                    <div class="cu_one" v-html="product.shuxing" v-if="$i18n.locale == 'zh'"></div>
                    <div class="cu_one" v-html="product.y_shuxing" v-else-if="$i18n.locale == 'en'"></div>
                    <div class="cu_one" v-html="product.e_shuxing" v-else></div>

                    <!-- <div class="cu_one">
                        <div>{{$t('pro.yd')}}：{{product.melting}} </div>
                        <div>{{$t('pro.fd')}}：{{product.boiling}} </div>
                        <div>{{$t('pro.md')}}：{{product.density}} </div>
                    </div>
                    <div class="cu_one">
                        <div>{{$t('pro.zdp')}}：{{product.refractive}}</div>
                        <div>{{$t('pro.sd')}}：{{product.lightning}}</div>
                        <div>{{$t('pro.zctj')}}：{{product.condition}} </div>
                    </div> -->
                </div>
                <!-- 安全信息 -->
                <div class="chan">{{$t('pro.aqxx')}}</div>
                <div class="pro_cen">
                    <div class="cu_one" v-html="product.anquan" v-if="$i18n.locale == 'zh'"></div>
                    <div class="cu_one" v-html="product.y_anquan" v-else-if="$i18n.locale == 'en'"></div>
                    <div class="cu_one" v-html="product.e_anquan" v-else></div>

                    <!-- <div class="cu_one">
                        <div>{{$t('pro.wxxfh')}}（GHS）：{{product.ghs}}</div>
                        <div>{{$t('pro.aqxx')}}：{{product.ghs_desc}}</div>
                    </div>
                    <div class="cu_one">
                        <div>{{$t('pro.wxxbm')}}：{{product.ghs_type}}</div>
                        <div>{{$t('pro.hgbm')}}：{{product.code}}</div>
                    </div> -->
                </div>
            </div>
            <!-- 参考文献 -->
            <div class='s_title'>
               {{$t('pro.ckwx')}}
            </div>
            <div class="pro_center">
                <div class=""  v-for="(val,key) in product.reference_arr" :key='key'>
                {{val}}
                </div>
            </div>
            <!-- MSDS下载 -->
            <div class='s_title'>
               MSDS{{$t('pro.xiazai')}}
            </div>
            <div class="pro_center">
                <div class="lese">
                    <div class="lets">{{ product.msds_name }}</div>
                    <div v-if="product.msds==''"> <a>  {{$t('pro.xiazai')}}<el-image src='./static/image/icon_download@2x.png'></el-image></a></div>
                    <div v-else> <a :href="product.msds">  {{$t('pro.xiazai')}}<el-image src='./static/image/icon_download@2x.png'></el-image></a></div>
                </div>
            </div>
            <!-- 产品纯度质量报告下载 -->
            <div class='s_title'>
               {{$t('pro.cdzl')}}
            </div>
            <div class="pro_center" style="margin-bottom:100px">
                <div class="lese" v-for="(val,key) in product.report_arr" :key='key'>
                    <div class="lets" v-if="$i18n.locale == 'zh'&& key==1" >{{val[1]}}</div>
                    <div class="lets" v-else-if="$i18n.locale == 'en'&& key==2" >{{val[2]}}</div>
                    <div class="lets" v-else-if="$i18n.locale == 'ru'&& key==3" >{{val[3]}}</div>
                    <div v-else-if="key==0"><a :href="val[0]">{{$t('pro.xiazai')}}<el-image src='./static/image/icon_download@2x.png'></el-image></a></div>
                </div>
            </div>
            <div class="banner">
                <div class="block">
                    <el-carousel trigger="click">
                        <el-carousel-item v-for="(val,key) in product.img_arr" :key="key">
                            <el-image :src="val" fit="contain"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </div>
		</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				product:{},
                obj:{}
			}
		},
		mounted() {
            console.log('$i18n.locale',this.$i18n.locale)
            console.log('$route.query',this.$route.query)
            this.obj = JSON.parse(this.$route.query.name)
            console.log('this.$route.query',this.obj)
            this.getPor()
		},
		methods: {
			// 
			getPor() {
				var that = this;
				this.$axios
					.post("/api/index/product_info", {
                        id:this.$route.query.id
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
                            console.log('product',ret.data.data)
							that.product = ret.data.data.product;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
		}
	}
</script>

<style lang="scss" scoped>
.product{
    position: relative;
}
    .banner {
			width:260px;
			height:250px;
            position: absolute;
            top:200px;
            right:200px;
            overflow: hidden;
			.el-image {
				width: 100%;
				// height: 400px;
			}
		}
	.main {
		background-color: #FFFFFF;
		width: 1200px;
        margin: 0 auto;
		display: flex;
		align-items: center;
		flex-direction: column;
		.el-carousel {
			width: 100%;
		}
        .pro{
            width: 1200px;
            line-height:30px;
            margin:40px 0 0;
            overflow: hidden;
            text-align: left;
        }	
        .title{
            width:1200px;
            margin:50px auto 0;
            line-height: 60px;
            background: #E5EBF5;
            color: #004098;
            padding: 0 20px;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: bold;
        }
        .pro_center{
            width: 1200px;
            border: 1px solid #F6F6F6;
            padding: 20px;
            overflow: hidden;
        }
        .chan{
            width: 1200px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 30px;
            color: #004098;
            margin-bottom: 0px;
        }
        .pro_cen{
            display: flex;
            margin-bottom:20px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 30px;
            color: #333333;
        }
        .cu_one{
            // width: 33%;
        }
        .s_title{
            width:1200px;
            margin:50px auto 0;
            line-height: 60px;
            background: #E5EBF5;
            color: #004098;
            padding: 0 20px;
            font-weight: bold;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
        }
        .lese{
            display: flex;
            justify-content:space-between;
            line-height: 30px;
        }
        .lese .el-image{
            width: 20px;
            height: 20px;
            vertical-align: -5px;
            margin-left: 10px;
        }
	}
</style>



// WEBPACK FOOTER //
// src/components/product/prodetail.vue